import React, { useEffect, useState, useRef } from 'react';
import { Modal, Tooltip, Input, Button, Select } from 'antd';
import DataTable from 'react-data-table-component';
import { CSVLink } from 'react-csv';
import 'antd/dist/antd.css';
import { useHistory } from "react-router-dom";
import {
    UPI_PAYOUT_ADMIN_LIST,
    UPI_PAYOUT_ADMIN_STATS
} from './../../../Utils/appConstants';
import { getRequest, postRequest } from './../../../Utils/AppApi';
import { ToastContainer, toast } from 'react-toastify';
import { getUser } from './../../../Utils/Common';
import { getUTCToLocalDateFormat } from './../../../Utils/function';

const { Option } = Select;

function UPIPayoutRequests() {
    const user = getUser();
    const history = useHistory();
    const csvLink = useRef();
    const limit = 10;

    // ================== LIST STATE ==================
    const [getData, setData]             = useState({ docs: [] });
    const [getCsvData, setCsvData]       = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage]                = useState(1);
    const [isLimit, setLimit]            = useState(limit);
    const [search, setSearch]            = useState("");
    const [searchInput, setSearchInput]  = useState("");
    const [statusFilter, setStatusFilter] = useState("ALL");
    const [claimingId, setClaimingId]    = useState(null);

    // ================== STATS ==================
    const [stats, setStats] = useState({
        PENDING: 0, IN_PROCESS: 0, APPROVED: 0, REJECTED: 0, totalRevenueCollected: 0
    });

    // ================== APPROVE MODAL ==================
    const [isModalApprove, setIsModalApprove] = useState(false);
    const [approveRequest, setApproveRequest] = useState(null);
    const [cbWalletId, setCbWalletId]         = useState("");
    const [approveRemark, setApproveRemark]   = useState("");
    const [approveSaving, setApproveSaving]   = useState(false);

    // ================== REJECT MODAL ==================
    const [isModalReject, setIsModalReject] = useState(false);
    const [rejectRequest, setRejectRequest] = useState(null);
    const [rejectReason, setRejectReason]   = useState("");
    const [doRefund, setDoRefund]           = useState(true);   // default ON
    const [rejectSaving, setRejectSaving]   = useState(false);

    // ================== VIEW MODAL ==================
    const [isModalView, setIsModalView] = useState(false);
    const [viewRequest, setViewRequest] = useState(null);

    // ================== STATUS BADGE ==================
    const getStatusBadge = (status) => {
        const map = {
            PENDING:    { cls: 'warning', label: 'PENDING' },
            IN_PROCESS: { cls: 'info',    label: 'IN PROCESS' },
            APPROVED:   { cls: 'success', label: 'APPROVED' },
            REJECTED:   { cls: 'danger',  label: 'REJECTED' }
        };
        const s = map[status] || map.PENDING;
        return <span className={`badge badge-${s.cls}`}>{s.label}</span>;
    };

    // ================== COLUMNS ==================
      // ================== COLUMNS ==================
      // ================== COLUMNS ==================
    const columns = [
     
        {
            name: 'Created At',
            cell: row => row.createdAt ? getUTCToLocalDateFormat(row.createdAt) : "—",
            width: "140px"
        },
        {
            name: 'Request ID',
            cell: row => (
                <Tooltip placement="bottom" title={row.requestId}>
                    <span style={{ fontFamily: 'monospace', fontSize: 12 }}>
                        {row.requestId}
                    </span>
                </Tooltip>
            ),
            sortable: true,
            width: "185px"
        },
        {
            name: 'User',
            cell: row => (
                <div>
                    <div>{row.name}</div>
                    <small className='text-muted'>{row.username}</small>
                </div>
            ),
            width: "160px"
        },
        {
            name: 'Mobile',
            selector: row => row.mobile || "—",
            width: "120px"
        },
        {
            name: 'PAN / Aadhar',
            cell: row => (
                <div>
                    <div style={{ fontFamily: 'monospace', fontSize: 11 }}>{row.panNumber}</div>
                    <div style={{ fontFamily: 'monospace', fontSize: 11 }} className='text-muted'>
                        {row.aadharNumber}
                    </div>
                </div>
            ),
            width: "150px"
        },
        {
            name: 'Parent',
            cell: row => (
                <div>
                    <div>{row.parentName || "—"}</div>
                    {row.parentUsername && <small className='text-muted'>{row.parentUsername}</small>}
                </div>
            ),
            width: "150px"
        },
        {
            name: 'Amount',
            selector: row => `₹${row.payment?.amount || 1000}`,
            width: "90px"
        },
        {
            name: 'Status',
            cell: row => getStatusBadge(row.status),
            width: "130px"
        },
        {
            name: 'CB Wallet ID',
            cell: row => row.cbWalletId ? (
                <Tooltip placement="bottom" title={row.cbWalletId}>
                    <span style={{ fontFamily: 'monospace', fontSize: 11, color: '#02A650', fontWeight: 600 }}>
                        {row.cbWalletId}
                    </span>
                </Tooltip>
            ) : "—",
            width: "140px"
        },

           {
            name: 'Action',
            cell: row => {
                if (row.status === 'PENDING') {
                    return (
                        <button
                            type="button"
                            className="btn btn-sm"
                            onClick={() => handleClaim(row)}
                            disabled={claimingId === row._id}
                            style={{ 
                                fontWeight: 600, 
                                backgroundColor: '#17a2b8', // Explicit Blue
                                color: '#ffffff',
                                border: '1px solid #17a2b8',
                                borderRadius: '4px',
                                padding: '4px 12px',
                                minWidth: '75px'
                            }}
                        >
                            {claimingId === row._id ? '...' : 'Submit'}
                        </button>
                    );
                }
                if (row.status === 'IN_PROCESS') {
                    return (
                        <div className="d-flex">
                            <button
                                type="button"
                                className="btn btn-sm mr-2"
                                onClick={() => handleOpenApprove(row)}
                                style={{ 
                                    fontWeight: 600, 
                                    backgroundColor: '#28a745', // Explicit Green
                                    color: '#ffffff',
                                    border: '1px solid #28a745',
                                    borderRadius: '4px',
                                    padding: '4px 12px'
                                }}
                            >
                                Approve
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm"
                                onClick={() => handleOpenReject(row)}
                                style={{ 
                                    fontWeight: 600, 
                                    backgroundColor: '#dc3545', // Explicit Red
                                    color: '#ffffff',
                                    border: '1px solid #dc3545',
                                    borderRadius: '4px',
                                    padding: '4px 12px'
                                }}
                            >
                                Reject
                            </button>
                        </div>
                    );
                }
                return (
                    <button
                        type="button"
                        className="btn btn-sm"
                        onClick={() => handleOpenView(row)}
                        style={{ 
                            fontWeight: 600, 
                            backgroundColor: '#6c757d', // Explicit Gray
                            color: '#ffffff',
                            border: '1px solid #6c757d',
                            borderRadius: '4px',
                            padding: '4px 12px'
                        }}
                    >
                        View
                    </button>
                );
            },
            width: "200px",
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        },
        // {
        //     name: 'Age',
        //     cell: row => (
        //         <div>
        //             <div>{row.agingDays} d</div>
        //             <small className='text-muted'>{row.agingBucket}</small>
        //         </div>
        //     ),
        //     width: "80px"
        // },
        
    ];
    // ================== HANDLERS ==================

    const objectToQueryString = (obj) => {
        const str = [];
        for (const p in obj)
            if (obj.hasOwnProperty(p) && obj[p] !== undefined && obj[p] !== null && obj[p] !== '') {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const getDataReports = (newLimit) => {
        const params = { page: page, limit: isLimit };
        if (newLimit) {
            setLimit(newLimit);
            params.limit = newLimit;
        }
        if (search) params.search = search;
        if (statusFilter && statusFilter !== 'ALL') params.status = statusFilter;

        const queryString = objectToQueryString(params);
        getRequest(`${UPI_PAYOUT_ADMIN_LIST}?${queryString}`, history).then((response) => {
            if (response.success === true && response.data) {
                setData(response.data);
                setTotalRecord(response.data.totalDocs || 0);
                setPage(response.data.page || 1);
            } else {
                setData({ docs: [] });
                setTotalRecord(0);
                setPage(1);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const getStats = () => {
        getRequest(`${UPI_PAYOUT_ADMIN_STATS}`, history).then((response) => {
            if (response.success === true && response.data) {
                setStats({
                    PENDING:    response.data.counts?.PENDING || 0,
                    IN_PROCESS: response.data.counts?.IN_PROCESS || 0,
                    APPROVED:   response.data.counts?.APPROVED || 0,
                    REJECTED:   response.data.counts?.REJECTED || 0,
                    totalRevenueCollected: response.data.totalRevenueCollected || 0
                });
            }
        }).catch(() => {});
    };

    const getCSVDataList = () => {
        const csvParams = { page: 1, limit: 10000 };
        if (search) csvParams.search = search;
        if (statusFilter && statusFilter !== 'ALL') csvParams.status = statusFilter;

        const queryString = objectToQueryString(csvParams);
        getRequest(`${UPI_PAYOUT_ADMIN_LIST}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                const csvdataRecord = [];
                const csvdata = response.data.docs || [];
                csvdata.forEach((e) => {
                    csvdataRecord.push({
                        "Request ID": e.requestId,
                        "Name": e.name,
                        "Username": e.username,
                        "Mobile": e.mobile || "",
                        "PAN": e.panNumber || "",
                        "Aadhar": e.aadharNumber || "",
                        "Parent": e.parentName || "",
                        "Parent Username": e.parentUsername || "",
                        "Amount": e.payment?.amount || 1000,
                        "Payment Status": e.payment?.status || "",
                        "Refund Txn ID": e.payment?.refundTxnId || "",
                        "Status": e.status,
                        "CB Wallet ID": e.cbWalletId || "",
                        "Rejection Reason": e.rejectionReason || "",
                        "Created At": e.createdAt ? getUTCToLocalDateFormat(e.createdAt) : "",
                        "Approved At": e.approvedAt ? getUTCToLocalDateFormat(e.approvedAt) : "",
                        "Rejected At": e.rejectedAt ? getUTCToLocalDateFormat(e.rejectedAt) : ""
                    });
                });
                setCsvData(csvdataRecord);
                setTimeout(() => csvLink.current.link.click(), 1000);
            } else {
                setCsvData([]);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const handleSearch = () => {
        setSearch(searchInput);
        setPage(1);
    };

    const handleClear = () => {
        setSearch("");
        setSearchInput("");
        setStatusFilter("ALL");
        setPage(1);
    };

    const handlePageChange = page => setPage(page);

    const handleStatusFilterChange = (value) => {
        setStatusFilter(value);
        setPage(1);
    };

    // ---- Claim ----
    const handleClaim = (row) => {
        if (!user?.data || user.data.role?.code !== "A") {
            toast.error("Only admin can claim requests");
            return;
        }
        setClaimingId(row._id);
        postRequest(`${UPI_PAYOUT_ADMIN_LIST}/${row._id}/claim`, {}, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message || 'Request claimed');
                getDataReports();
                getStats();
            } else {
                toast.error(response.message || 'Failed to claim');
            }
        }).catch(() => {
            toast.error("Failed to claim request");
        }).finally(() => {
            setClaimingId(null);
        });
    };

    // ---- Open Approve ----
    const handleOpenApprove = (row) => {
        if (!user?.data || user.data.role?.code !== "A") {
            toast.error("Only admin can approve");
            return;
        }
        setApproveRequest(row);
        setCbWalletId("");
        setApproveRemark("");
        setIsModalApprove(true);
    };

    // ---- Open Reject ----
    const handleOpenReject = (row) => {
        if (!user?.data || user.data.role?.code !== "A") {
            toast.error("Only admin can reject");
            return;
        }
        setRejectRequest(row);
        setRejectReason("");
        setDoRefund(true);
        setIsModalReject(true);
    };

    // ---- Open View ----
    const handleOpenView = (row) => {
        setViewRequest(row);
        setIsModalView(true);
    };

    // ---- Submit Approve ----
    const handleSubmitApprove = () => {
        if (!approveRequest) return;
        const trimmed = cbWalletId.trim();
        if (!trimmed) {
            toast.error("CB Wallet ID is required");
            return;
        }
        if (trimmed.length < 3) {
            toast.error("CB Wallet ID must be at least 3 characters");
            return;
        }
        if (!/^[A-Z0-9_\-]+$/i.test(trimmed)) {
            toast.error("CB Wallet ID may only contain letters, numbers, hyphens and underscores");
            return;
        }

        setApproveSaving(true);
        const payload = {
            cbWalletId: trimmed,
            remark: approveRemark.trim()
        };

        postRequest(`${UPI_PAYOUT_ADMIN_LIST}/${approveRequest._id}/approve`, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message || 'Request approved');
                setIsModalApprove(false);
                setApproveRequest(null);
                setCbWalletId("");
                setApproveRemark("");
                getDataReports();
                getStats();
            } else {
                toast.error(response.message || 'Failed to approve');
            }
        }).catch(() => {
            toast.error("Failed to approve request");
        }).finally(() => {
            setApproveSaving(false);
        });
    };

    // ---- Submit Reject ----
    const handleSubmitReject = () => {
        if (!rejectRequest) return;
        if (!rejectReason || rejectReason.trim().length < 5) {
            toast.error("Rejection reason must be at least 5 characters");
            return;
        }

        setRejectSaving(true);
        const payload = {
            remark: rejectReason.trim(),
            refund: doRefund
        };

        postRequest(`${UPI_PAYOUT_ADMIN_LIST}/${rejectRequest._id}/reject`, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message || 'Request rejected');
                setIsModalReject(false);
                setRejectRequest(null);
                setRejectReason("");
                setDoRefund(true);
                getDataReports();
                getStats();
            } else {
                toast.error(response.message || 'Failed to reject');
            }
        }).catch(() => {
            toast.error("Failed to reject request");
        }).finally(() => {
            setRejectSaving(false);
        });
    };

    useEffect(() => {
        getDataReports();
    }, [page, statusFilter, search]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        getStats();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // ================== RENDER ==================
    return (
        <div>
            <div className="container-fluid pt-2 pb-5">
                <div className="content-header my-0 py-0">
                    <div className="container-fluid mb-3 ml-2">
                        <div className="row mb-0 align-items-center">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>
                                    UPI Payout <span className='text-red'>Registrations</span>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ---- Stats ---- */}
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-md-2 col-6 mb-2">
                            <div className='info-box' style={{ background: '#FEF3C7' }}>
                                <div className='info-box-content'>
                                    <span className='info-box-text text-warning'>Pending</span>
                                    <span className='info-box-number' style={{ fontSize: 22 }}>{stats.PENDING}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 col-6 mb-2">
                            <div className='info-box' style={{ background: '#DBEAFE' }}>
                                <div className='info-box-content'>
                                    <span className='info-box-text text-info'>In Process</span>
                                    <span className='info-box-number' style={{ fontSize: 22 }}>{stats.IN_PROCESS}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 col-6 mb-2">
                            <div className='info-box' style={{ background: '#D1FAE5' }}>
                                <div className='info-box-content'>
                                    <span className='info-box-text text-success'>Approved</span>
                                    <span className='info-box-number' style={{ fontSize: 22 }}>{stats.APPROVED}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 col-6 mb-2">
                            <div className='info-box' style={{ background: '#FEE2E2' }}>
                                <div className='info-box-content'>
                                    <span className='info-box-text text-danger'>Rejected</span>
                                    <span className='info-box-number' style={{ fontSize: 22 }}>{stats.REJECTED}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-12 mb-2">
                            <div className='info-box' style={{ background: '#F1F5F9' }}>
                                <div className='info-box-content'>
                                    <span className='info-box-text text-secondary'>Total Revenue Collected</span>
                                    <span className='info-box-number' style={{ fontSize: 22 }}>
                                        ₹{stats.totalRevenueCollected}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    {user?.data?.role?.code === "A" &&
                        <div className='float-sm-right d-flex mb-1'>
                            <button
                                type="button"
                                className="btn btn-primary mr-3"
                                onClick={() => getCSVDataList()}
                            >
                                <i className="fa fa-file-excel"></i> Export
                            </button>
                            <CSVLink
                                data={getCsvData}
                                filename='upi-payout-requests.csv'
                                className='hidden'
                                ref={csvLink}
                                target='_blank'
                            />
                        </div>}

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <Input
                                placeholder="Search by request ID, username, mobile, PAN…"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onPressEnter={handleSearch}
                                allowClear
                            />
                        </div>
                        <div className="col-md-3">
                            <Select
                                value={statusFilter}
                                onChange={handleStatusFilterChange}
                                style={{ width: '100%' }}
                            >
                                <Option value="ALL">All Status</Option>
                                <Option value="PENDING">Pending</Option>
                                <Option value="IN_PROCESS">In Process</Option>
                                <Option value="APPROVED">Approved</Option>
                                <Option value="REJECTED">Rejected</Option>
                            </Select>
                        </div>
                        <div className="col-md-5">
                            <Button type="primary" onClick={handleSearch}>Search</Button>
                            <Button type="default" onClick={handleClear} className='ml-2'>Clear</Button>
                        </div>
                    </div>

                    <div className="box-body">
                        <DataTable
                            columns={columns}
                            data={getData.docs}
                            highlightOnHover
                            pagination
                            paginationServer
                            striped
                            paginationTotalRows={getTotalRecord}
                            onChangeRowsPerPage={getDataReports}
                            onChangePage={handlePageChange}
                            noDataComponent={
                                <div className='text-center text-muted py-4'>
                                    No UPI Payout registrations found.
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                limit={2}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />

            {/* --------- Approve Modal --------- */}
            {isModalApprove && approveRequest &&
                <Modal
                    title={
                        <span>
                            <i className="fa fa-check-circle mr-2 text-success" />
                            Approve Request — {approveRequest.requestId}
                        </span>
                    }
                    width={560}
                    open={isModalApprove}
                    onOk={handleSubmitApprove}
                    onCancel={() => {
                        setIsModalApprove(false);
                        setApproveRequest(null);
                        setCbWalletId("");
                        setApproveRemark("");
                    }}
                    okText="Approve & Assign"
                    cancelText="Cancel"
                    confirmLoading={approveSaving}
                    okButtonProps={{
                        style: {
                            background: '#02A650',
                            borderColor: '#02A650',
                            fontWeight: 600
                        }
                    }}
                >
                    <div className='row'>
                        <div className='col-md-12 mb-3'>
                            <div className='alert alert-info mb-0' style={{ fontSize: 12 }}>
                                <div><strong>User:</strong> {approveRequest.name} ({approveRequest.username})</div>
                                <div><strong>Mobile:</strong> {approveRequest.mobile}</div>
                                <div><strong>PAN:</strong> {approveRequest.panNumber}</div>
                                <div><strong>Amount Paid:</strong> ₹{approveRequest.payment?.amount || 1000}</div>
                            </div>
                        </div>
                        <div className='col-md-12 form-group'>
                            <label>CB Wallet ID <span className='text-danger'>*</span></label>
                            <Input
                                placeholder='e.g. CBW-USER-78421'
                                value={cbWalletId}
                                onChange={(e) => setCbWalletId(e.target.value.toUpperCase())}
                                autoFocus
                                style={{ fontFamily: 'monospace', letterSpacing: '0.5px' }}
                            />
                            <small className='text-muted'>
                                This will be saved to <code>userDetails.cbWalletId</code> and cannot be modified after approval.
                            </small>
                        </div>
                        <div className='col-md-12 form-group'>
                            <label>Internal Remark <small className='text-muted'>(optional)</small></label>
                            <textarea
                                className='form-control'
                                rows={2}
                                placeholder='Any notes for audit trail'
                                value={approveRemark}
                                onChange={(e) => setApproveRemark(e.target.value)}
                                style={{ borderRadius: 8, resize: 'none' }}
                            />
                        </div>
                    </div>
                </Modal>}

            {/* --------- Reject Modal --------- */}
            {isModalReject && rejectRequest &&
                <Modal
                    title={
                        <span>
                            <i className="fa fa-times-circle mr-2 text-danger" />
                            Reject Request — {rejectRequest.requestId}
                        </span>
                    }
                    width={560}
                    open={isModalReject}
                    onOk={handleSubmitReject}
                    onCancel={() => {
                        setIsModalReject(false);
                        setRejectRequest(null);
                        setRejectReason("");
                        setDoRefund(true);
                    }}
                    okText="Reject & Refund"
                    cancelText="Cancel"
                    confirmLoading={rejectSaving}
                    okButtonProps={{
                        style: {
                            background: '#DC2626',
                            borderColor: '#DC2626',
                            fontWeight: 600
                        }
                    }}
                >
                    <div className='row'>
                        <div className='col-md-12 mb-3'>
                            <div className='alert alert-warning mb-0' style={{ fontSize: 12 }}>
                                <div><strong>User:</strong> {rejectRequest.name} ({rejectRequest.username})</div>
                                <div><strong>Amount Paid:</strong> ₹{rejectRequest.payment?.amount || 1000}</div>
                            </div>
                        </div>
                        <div className='col-md-12 form-group'>
                            <label>Rejection Reason <span className='text-danger'>*</span></label>
                            <textarea
                                className='form-control'
                                rows={3}
                                placeholder='Explain why this registration is being rejected (shown to the user)'
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                                style={{ borderRadius: 8, resize: 'none' }}
                                autoFocus
                            />
                            <small className='text-muted'>
                                {rejectReason.trim().length} / 5 chars minimum
                            </small>
                        </div>
                        <div className='col-md-12 form-group'>
                            <label className='d-flex align-items-start' style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <input
                                    type="checkbox"
                                    checked={doRefund}
                                    onChange={(e) => setDoRefund(e.target.checked)}
                                    style={{ marginTop: 3, marginRight: 8, width: 16, height: 16, accentColor: '#02A650' }}
                                />
                                <div>
                                    <div style={{ fontWeight: 600, color: '#1A1A2E' }}>
                                        Refund ₹{rejectRequest.payment?.amount || 1000} to user's wallet
                                    </div>
                                    <small className='text-muted'>
                                        Uncheck only for fraud / discard cases. Refund is processed immediately on rejection.
                                    </small>
                                </div>
                            </label>
                        </div>
                    </div>
                </Modal>}

            {/* --------- View Modal --------- */}
            {isModalView && viewRequest &&
                <Modal
                    title={
                        <span>
                            <i className={`fa ${viewRequest.status === 'APPROVED' ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'} mr-2`} />
                            {viewRequest.status === 'APPROVED' ? 'Approved' : 'Rejected'} — {viewRequest.requestId}
                        </span>
                    }
                    width={640}
                    open={isModalView}
                    onCancel={() => {
                        setIsModalView(false);
                        setViewRequest(null);
                    }}
                    footer={[
                        <button
                            key="close"
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                                setIsModalView(false);
                                setViewRequest(null);
                            }}
                        >
                            Close
                        </button>
                    ]}
                >
                    <div className='row'>
                        <div className='col-md-12 mb-3'>
                            <table className='table table-sm table-bordered mb-0'>
                                <tbody>
                                    <tr>
                                        <td style={{ width: 140, fontWeight: 600, background: '#F8FAFC' }}>Name</td>
                                        <td>{viewRequest.name}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: 600, background: '#F8FAFC' }}>Username</td>
                                        <td>{viewRequest.username}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: 600, background: '#F8FAFC' }}>Mobile</td>
                                        <td>{viewRequest.mobile}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: 600, background: '#F8FAFC' }}>PAN</td>
                                        <td style={{ fontFamily: 'monospace' }}>{viewRequest.panNumber}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: 600, background: '#F8FAFC' }}>Aadhar</td>
                                        <td style={{ fontFamily: 'monospace' }}>{viewRequest.aadharNumber}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: 600, background: '#F8FAFC' }}>Parent</td>
                                        <td>
                                            {viewRequest.parentName || '—'}
                                            {viewRequest.parentUsername && <small className='text-muted'> ({viewRequest.parentUsername})</small>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: 600, background: '#F8FAFC' }}>Amount Paid</td>
                                        <td>₹{viewRequest.payment?.amount || 1000}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {viewRequest.status === 'APPROVED' && (
                            <div className='col-md-12 mb-3'>
                                <div className='alert alert-success mb-0'>
                                    <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', opacity: 0.8 }}>
                                        CB Wallet ID
                                    </div>
                                    <div style={{ fontFamily: 'monospace', fontSize: 18, fontWeight: 700, marginTop: 4 }}>
                                        {viewRequest.cbWalletId || viewRequest.upiPayoutCredentials?.partnerId || '—'}
                                    </div>
                                    <small className='text-muted'>
                                        Assigned: {viewRequest.cbWalletAssignedAt
                                            ? getUTCToLocalDateFormat(viewRequest.cbWalletAssignedAt)
                                            : (viewRequest.approvedAt ? getUTCToLocalDateFormat(viewRequest.approvedAt) : '—')}
                                    </small>
                                </div>
                            </div>
                        )}

                        {viewRequest.status === 'REJECTED' && (
                            <>
                                <div className='col-md-12 mb-3'>
                                    <div className='alert alert-danger mb-0'>
                                        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', opacity: 0.8 }}>
                                            Rejection Reason
                                        </div>
                                        <div style={{ marginTop: 4, whiteSpace: 'pre-wrap' }}>
                                            {viewRequest.rejectionReason || '—'}
                                        </div>
                                        <small className='text-muted'>
                                            Rejected: {viewRequest.rejectedAt ? getUTCToLocalDateFormat(viewRequest.rejectedAt) : '—'}
                                        </small>
                                    </div>
                                </div>
                                <div className='col-md-12 mb-3'>
                                    <div className='alert alert-info mb-0'>
                                        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', opacity: 0.8 }}>
                                            Refund Status
                                        </div>
                                        {viewRequest.payment?.status === 'REFUNDED' ? (
                                            <>
                                                <div style={{ fontWeight: 600, color: '#02A650', marginTop: 4 }}>
                                                    Refunded ₹{viewRequest.payment.amount}
                                                    {viewRequest.payment.refundTxnId && (
                                                        <span style={{ fontFamily: 'monospace', fontSize: 11, marginLeft: 8, opacity: 0.7 }}>
                                                            ({viewRequest.payment.refundTxnId})
                                                        </span>
                                                    )}
                                                </div>
                                                <small className='text-muted'>
                                                    on {viewRequest.payment.refundedAt ? getUTCToLocalDateFormat(viewRequest.payment.refundedAt) : '—'}
                                                </small>
                                            </>
                                        ) : (
                                            <div style={{ color: '#D97706', fontWeight: 600, marginTop: 4 }}>
                                                Not refunded (payment status: {viewRequest.payment?.status || 'unknown'})
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </Modal>}
        </div>
    );
}

export default UPIPayoutRequests;